import React from "react";
import { Box } from "@mui/material";
import Row from "../../../components/Row";
import { colors } from "../../../utils/constants";
import LoginIcon from "@mui/icons-material/Login";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { landingTokens } from "../theme";

interface ForParticipantsProps {
  isMobile: boolean;
}

const steps = [
  { icon: <LoginIcon />, number: "01", label: "Acesse o evento" },
  { icon: <FactCheckIcon />, number: "02", label: "Faça os checkins" },
  { icon: <WorkspacePremiumIcon />, number: "03", label: "Emita o certificado" },
];

function ForParticipants({ isMobile }: ForParticipantsProps) {
  const styles = {
    containerStyle: {
      background: landingTokens.gradient,
      padding: isMobile ? 4 : 10,
      paddingLeft: isMobile ? 4 : 16,
      paddingRight: isMobile ? 4 : 16,
    },
    titleStyle: {
      fontSize: isMobile ? 22 : 32,
      fontWeight: 600,
      color: colors.white,
      width: isMobile ? "100%" : "25%",
      display: "flex",
      alignItems: "flex-start",
      gap: "12px",
    },
    descriptionStyle: {
      fontSize: 16,
      marginTop: isMobile ? 24 : 8,
      width: isMobile ? "100%" : "60%",
      paddingLeft: isMobile ? 0 : 120,
      textAlign: "left" as const,
      color: colors.white,
    },
    stepsContainer: {
      position: "relative" as const,
      display: "flex",
      flexDirection: isMobile ? ("column" as const) : ("row" as const),
      gap: isMobile ? "36px" : "0",
      marginTop: isMobile ? "48px" : "64px",
    },
    connectorLine: {
      position: "absolute" as const,
      top: "34px",
      left: "16.5%",
      right: "16.5%",
      height: 2,
      backgroundColor: "rgba(255,255,255,0.3)",
      zIndex: 0,
    },
    step: {
      position: "relative" as const,
      zIndex: 1,
      flex: 1,
      display: "flex",
      flexDirection: "column" as const,
      alignItems: isMobile ? "flex-start" : "center",
      textAlign: isMobile ? ("left" as const) : ("center" as const),
      gap: "18px",
    },
    stepCircle: {
      width: 68,
      height: 68,
      borderRadius: "50%",
      border: "2px solid rgba(255,255,255,0.55)",
      backgroundColor: "rgba(0,60,150,0.35)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: colors.white,
      fontSize: 28,
      flexShrink: 0,
    },
    stepNumber: {
      fontSize: 13,
      fontWeight: 700,
      letterSpacing: "0.12em",
      color: "rgba(255,255,255,0.65)",
    },
    stepLabel: {
      fontSize: isMobile ? 18 : 20,
      fontWeight: 700,
      color: colors.white,
    },
  };

  return (
    <Box sx={styles.containerStyle}>
      <Row style={{ flexDirection: isMobile ? "column" : "row" }}>
        <Box component="span" sx={styles.titleStyle}>
          <CheckCircleIcon /> Para quem participa de eventos
        </Box>
        <span style={styles.descriptionStyle}>
          Para os participantes, uma forma automática de gerar seu certificado assim que tiver a
          quantidade necessária de presença para a emissão do certificado.
        </span>
      </Row>

      <Box sx={styles.stepsContainer}>
        {!isMobile && <Box sx={styles.connectorLine} />}
        {steps.map((step) => (
          <Box key={step.label} sx={styles.step}>
            <Box sx={styles.stepCircle}>{step.icon}</Box>
            <Box>
              <Box component="div" sx={styles.stepNumber}>
                PASSO {step.number}
              </Box>
              <Box component="div" sx={styles.stepLabel}>
                {step.label}
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default ForParticipants;
